<script>
import service from "../services/HttpRequestService";

export default {
  methods: {
    redirectToDealsPageWithError(errorMessage) {
      this.$router.push({path: 'deal_catalog', query: {error: errorMessage}});
    },
    redirectToNextPage(basedOnCusip = true) {
      if (!basedOnCusip) {
        this.$router.push({path: 'deal_catalog'});
      } else {
        let cusip = this.$route.query.utm_term;
        service.logTrialAccess(this.$route.query)
        if (cusip) {
          service.getDealAndBondIdByCusip(cusip).then(result => {
            if (result.data.DealName) {
              let queryObject = {...this.$route.query, ...{dealName: result.data.DealName, bondName: result.data.BondName}}
              this.$router.push({path: 'bond_analysis', query: queryObject});
            } else {
              this.redirectToDealsPageWithError('Deal was not found');
            }
          }).catch(err => {
            this.redirectToDealsPageWithError(err.response.data.Message);
          })
        } else {
          this.$router.push({path: 'deal_catalog', query: {}});
          // CRTHUB-194: Error message is suppressed for Trial Users
          // this.redirectToDealsPageWithError('Cusip is not provided');
        }
      }
    }
  }
}
</script>
